export enum Gender {
  Male = "MALE",
  Female = "FEMALE",
  Other = "OTHER",
  None = "NONE",
}
